import React from 'react';
import Axios from 'axios';
import {Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardHeader, CardBody} from 'reactstrap';
import moment from 'moment';

class RatingEditModal extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			rating: this.props.modalRating,
			selectedRatingType: {
				values: []
			},
			disableSubmit: false
		};

		this.handleInputChg = this.handleInputChg.bind(this);
		this.handleRatingTempChange = this.handleRatingTempChange.bind(this);
		this.handleSaveRating = this.handleSaveRating.bind(this);
	}

	componentDidMount() {
		// console.log('RatingEditModal: componentDidMount');
		this.initModalState(this.props);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		// console.log('RatingEditModal: UNSAFE_componentWillReceiveProps');
		this.initModalState(nextProps);
	}

	initModalState(props) {
		// console.log('%c initModalState: selectedRatingType', 'background-color: #ffe000; color: #ba0000; font-weight: bold');

		var rating = props.modalRating;

		// set ratingValues
		var selectedRatingType = this.state.selectedRatingType;
		if (rating !== {}) {
			props.ratingTypes.forEach(function (rt, rtidx, ratingTypes) {
				if (rt._id.toString() === rating.ratingTypeId.toString()) {
					selectedRatingType = rt;
				}
			});
		}

		this.setState({
			rating: rating,
			selectedRatingType: selectedRatingType,
			disableSubmit: false
		});
	}

	render() {
		//console.log('RatingEditModal: render');
		//console.log(this.state.rating);

		return (
    	<Modal 
  			isOpen={this.props.showModal} 
    		//toggle={this.props.handleModalCancel}		// when clicking outside the modal
				size="sm"
    		className={this.props.className}>

        <form className="form-horizontal" onSubmit={this.handleSaveRating}>
    		<ModalHeader 
    			toggle={this.props.handleModalCancel}>	{/* displays a small X in header */}
    			Cotation
    		</ModalHeader>

    		<ModalBody>
					{this.dispForm()}
    		</ModalBody>

    		<ModalFooter>
      		<button type="button" className="btn btn-secondary btn-sm stdCommandButton2" 
      			onClick={this.props.handleModalCancel}> Annuler
      		</button>
      		<button type="submit" className="btn btn-primary btn-sm stdCommandButton2"> 
      			Soumettre
      		</button>
    		</ModalFooter>
        </form>
    	</Modal>
    )
	}

	dispForm() {

		var rating = this.state.rating;
		var ratingDate = moment(rating.date).utc().format('YYYY-MM-DD');
    var defaultDate = moment(new Date()).format("YYYY-MM-DD");

		return (
			<div>
        <div className="row row-margin-bottom-10">
        <div className="col-md-12">
					<strong> {this.props.playerName} </strong>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-md-8">
					<span className="small"> Date de la cotation </span> <br/>
          <input className="form-control form-control-sm" type="date" id="date" 
          	value={ratingDate || defaultDate} required
            onChange={this.handleInputChg}></input>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-md-10">
					<span className="small"> Système de cotation </span> <br/>
		  		<select className="form-control form-control-sm input-sm" type="text" id="ratingTypeId" 
		  			value={this.state.rating.ratingTypeId} onChange={this.handleInputChg} required>
		  				{this.props.ratingTypes.map(this.optRatingTypes)}
					</select>
					<i className="small"> Systèmes de cotation dont vous êtes organisateur.</i>
				</div>
				</div>

        <div className="row">
        <div className="col-md-4">
					<span className="small"> Cote </span> <br/>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-md-4 row-margin-bottom-10">
					{this.dispRatingValueSelector()}
				</div>
        <div className="col-md-8">
					<label className="switch switch-3d switch-success">
					<input type="checkbox" className="switch-input" checked={this.state.rating.ratingTemp || false} 
          	onChange={this.handleRatingTempChange}/>
	          <span className="switch-label"> </span>
	          <span className="switch-handle"> </span>
					</label> Temporaire
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-md-12">
					<span className="small"> Notes / Commentaires </span> <br/>
					<input type="text" className="form-control form-control-sm" name="comment" id="comment"
						value={rating.comment || ''} onChange={this.handleInputChg} />
				</div>
				</div>

			</div>
		)
	}

	optRatingTypes(rt, rtIdx, ratingTypes) {
		return (
			<option value={rt._id} key={'opt.rt.' + rtIdx}> {rt.name} </option>
		)
	}

	dispRatingValueSelector() {
		var rating = this.state.rating;
		var selectedRatingTypeValues = this.state.selectedRatingType.values;

		// console.log('selectedRatingTypeValues');
		// console.log(selectedRatingTypeValues);

		// console.log('rating');
		// console.log(rating);

		// if rating type has predefined values
		if (selectedRatingTypeValues.length !== 0) {
			return(
  			<select className="form-control form-control-sm input-sm" type="text" id="ratingValue" 
  				value={rating.ratingValue} onChange={this.handleInputChg} required>
  					{selectedRatingTypeValues.map(this.optRatingTypesValues)}
				</select>
			)
		} else {
			return (
				<input type="text" className="form-control form-control-sm" name="ratingValue" id="ratingValue"
					value={rating.ratingValue || ''} onChange={this.handleInputChg} required />
			)
		}
	}

	optRatingTypesValues(rtv, rtvIdx, ratingTypesValues) {
		return (
			<option value={rtv} key={'opt.rtv.' + rtvIdx}> {rtv} </option>
		)
	}

	handleInputChg(e) {
		var rating = this.state.rating;
		var selectedRatingType = this.state.selectedRatingType;

		rating[e.target.id] = e.target.value;

		// set ratingValues
		if (e.target.id === 'ratingTypeId') {
			this.props.ratingTypes.forEach(function (rt, rtidx, ratingTypes) {
				if (rt._id.toString() === rating.ratingTypeId.toString()) {
					selectedRatingType = rt;
				}
			});

			// console.log('%c handleInputChg: selectedRatingType', 'background-color: #ffe000; color: #0000ba; font-weight: bold');
			
			// if predefined values are defined, find the one in list, if not found, use .values[0] as default
			if (selectedRatingType.values.length !== 0) {
				var previousRatingTypeValueExistsInNew = false;
				selectedRatingType.values.forEach(function(rtv, rtvIdx) {

					// same value existing ?
					if (rtv === rating.ratingValue) {
						previousRatingTypeValueExistsInNew = true;
					}
				});
				if (!previousRatingTypeValueExistsInNew) {
					rating.ratingValue = selectedRatingType.values[0];
				}
			} else {
				rating.ratingValue = '';
			}
		}

		this.setState({
			rating: rating,
			selectedRatingType: selectedRatingType
		});
	}

	handleRatingTempChange(e) {
		var rating = this.state.rating;
		rating.ratingTemp = e.target.checked;
		this.setState({
			rating: rating
		});
	}

	handleSaveRating(e) {

		// console.log('handleSaveRating !');
		e.preventDefault();

		if (this.state.disableSubmit) {
			return;
		}

		var _this = this;
		var rating = this.state.rating;

		// Set user Id
		rating.userId = this.props.userId;
		rating.playerId = this.props.playerId;

		_this.setState({
			disableSubmit: true
		});

		// Post rating
		Axios.post('/api/players/setPlayerRating/', {
			ratingObj: rating,
		})
		.then(function(response) {
/*
			_this.setState({
				disableSubmit: false
			});
*/
			_this.props.loadPlayer();
			_this.props.handleModalCancel();

		})
		.catch(function(error) {
			console.log('ERROR');
			console.log(error);
			_this.props.handleModalCancel();
		});
	}

}

export default RatingEditModal;